(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel-grid"] && !Shopify.designMode) return;
  try {
    class CarouselSlider extends HTMLElement {
    connectedCallback() {
      this.init();
    }
    init() {
      if (this._initialized) return;
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      var isCarousel = this.classList.contains('carousel-grid--carousel');
      // In modalità carosello con track ancora vuoto (es. recently-viewed popolato via fetch dopo il
      // mount) non marcare come inizializzato: così una successiva chiamata a init() — dopo il
      // popolamento — aggancia correttamente items/frecce/dots invece di essere bloccata dalla guardia.
      if (isCarousel && this.track.children.length === 0) return;

      this._initialized = true;
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.dotsWrap = this.querySelector('[data-dots]');
      this.loop = this.dataset.loop === 'true';
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!isCarousel) return;

      this.items = Array.from(this.track.children);
      if (this.dotsWrap) this.buildDots();
      this.updateArrowState();
      this.track.addEventListener('scroll', () => {
        this.updateArrowState();
        this.updateDots();
      }, { passive: true });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByStep(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByStep(1));

      if (this.autoplay && !this.reducedMotion) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
      }

      let resizeTimer;
      this._onResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => { if (this.dotsWrap) this.buildDots(); }, 200);
      };
      window.addEventListener('resize', this._onResize);

      // Theme Editor: mette in pausa l'autoplay e scorre l'item in view mentre il merchant lo seleziona.
      this.addEventListener('shopify:section:select', (e) => this.revealSelected(e));
      this.addEventListener('shopify:block:select', (e) => this.revealSelected(e));
      this.addEventListener('shopify:section:deselect', () => this.startAutoplay());
      this.addEventListener('shopify:block:deselect', () => this.startAutoplay());
    }
    revealSelected(e) {
      this.stopAutoplay();
      const target = e.target && this.track.contains(e.target) ? e.target : null;
      if (!target) return;
      const trackRect = this.track.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const offset = targetRect.left - trackRect.left + this.track.scrollLeft;
      this.track.scrollTo({ left: offset, behavior: this.reducedMotion ? 'auto' : 'smooth' });
    }
    disconnectedCallback() {
      this.stopAutoplay();
      this._initialized = false;
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }
    stepWidth() {
      if (!this.items.length) return 0;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap || style.gap || 0);
      return this.items[0].getBoundingClientRect().width + gap;
    }
    scrollByStep(dir) {
      const width = this.stepWidth();
      const behavior = this.reducedMotion ? 'auto' : 'smooth';
      let next = this.track.scrollLeft + dir * width;
      if (this.loop) {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (next < 0) next = max;
        else if (next > max - 1) next = 0;
      }
      this.track.scrollTo({ left: next, behavior });
    }
    buildDots() {
      const width = this.track.clientWidth || 1;
      const pageCount = Math.max(1, Math.round(this.track.scrollWidth / width));
      this.dotsWrap.innerHTML = '';
      for (let i = 0; i < pageCount; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'carousel-grid__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-selected', 'false');
        dot.setAttribute('aria-label', String(i + 1));
        dot.addEventListener('click', () => {
          this.track.scrollTo({ left: i * width, behavior: this.reducedMotion ? 'auto' : 'smooth' });
        });
        this.dotsWrap.appendChild(dot);
      }
      this.updateDots();
    }
    updateDots() {
      if (!this.dotsWrap) return;
      const width = this.track.clientWidth || 1;
      const index = Math.round(this.track.scrollLeft / width);
      Array.from(this.dotsWrap.children).forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }
    updateArrowState() {
      if (!this.prevBtn && !this.nextBtn) return;
      if (this.loop) {
        if (this.prevBtn) this.prevBtn.disabled = false;
        if (this.nextBtn) this.nextBtn.disabled = false;
        return;
      }
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= max;
    }
    startAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      this._timer = setInterval(() => this.scrollByStep(1), this.autoplaySpeed);
    }
    stopAutoplay() {
      clearInterval(this._timer);
    }
  }
  if (!customElements.get('carousel-slider')) {
    customElements.define('carousel-slider', CarouselSlider);
  }
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('carousel-slider').forEach((el) => {
      if (typeof el.init === 'function') el.init();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('change', () => this.form.requestSubmit());
    }
  }
  if (!customElements.get('facet-filters')) {
    customElements.define('facet-filters', FacetFilters);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.medias = Array.from(this.querySelectorAll('.gallery__media'));
      this.counter = this.querySelector('[data-counter]');
      this.lightbox = this.querySelector('[data-lightbox]');
      this.stage = this.querySelector('.gallery__stage');
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(thumb.dataset.mediaId));
      });
      this.querySelectorAll('[data-zoom]').forEach((btn) => {
        btn.addEventListener('click', () => this.openLightbox(btn.dataset.zoom));
      });
      const prevArrow = this.querySelector('[data-gallery-prev]');
      const nextArrow = this.querySelector('[data-gallery-next]');
      if (prevArrow) prevArrow.addEventListener('click', () => this.step(-1));
      if (nextArrow) nextArrow.addEventListener('click', () => this.step(1));
      if (this.lightbox) {
        this.lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => this.lightbox.close());
        this.lightbox.addEventListener('click', (e) => { if (e.target === this.lightbox) this.lightbox.close(); });
      }
      this.addEventListener('gallery:select', (e) => this.show(e.detail.mediaId));
      this.initSlider();
      // The mobile/desktop slider gating is evaluated at mount time and on
      // shopify:section:load only, so resizing the viewport across the 749px
      // breakpoint (no reload in between) left the dots painted by CSS with no
      // handler/observer behind them. Re-run initSlider() on resize (debounced,
      // same pattern as carousel-grid.liquid's twin widget) -- it already tears
      // down its own previous observer/listeners before rebinding, so repeated
      // calls stay idempotent and never leave duplicate observers.
      let resizeTimer;
      this._onResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.initSlider(), 200);
      };
      window.addEventListener('resize', this._onResize);
    }
    // Twin of CarouselSlider.disconnectedCallback (carousel-grid.liquid): without it, a Theme
    // Editor settings change re-renders the section, the old <media-gallery> instance leaves the
    // DOM, but its `resize` listener on `window` stays bound and keeps the whole element (plus its
    // IntersectionObserver) alive — leaking one instance per re-render.
    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._sliderObserver) {
        this._sliderObserver.disconnect();
        this._sliderObserver = null;
      }
      if (this._sliderCleanup) {
        this._sliderCleanup();
        this._sliderCleanup = null;
      }
    }
    motionOff() {
      return document.body.classList.contains('animations-off') ||
        !window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
    }
    /* Mobile-only slider enhancement: dot click scrolls the stage, an
       IntersectionObserver on the stage's own scroll keeps the dots (and the
       hidden-but-kept-in-sync counter) in step with whatever slide the user
       swiped to. Registered only under the 749px breakpoint and re-evaluated
       on shopify:section:load (Theme Editor re-render); idempotent, so it can
       be called again safely without double-binding listeners/observers. */
    initSlider() {
      if (this._sliderObserver) {
        this._sliderObserver.disconnect();
        this._sliderObserver = null;
      }
      if (this._sliderCleanup) {
        this._sliderCleanup();
        this._sliderCleanup = null;
      }
      if (!this.stage || !this.dots.length || !window.matchMedia('(max-width: 749px)').matches) return;
      // Align the stage to whichever .gallery__media Liquid already marked
      // .is-active (may not be the first one, e.g. a variant preselected via
      // URL) before observing: no animation, so nothing is perceived to move.
      // Without this the stage stays at its default scrollLeft:0 and the
      // IntersectionObserver's initial notification below would flip the
      // correct dot back to #1.
      const activeMedia = this.medias.find((m) => m.classList.contains('is-active'));
      if (activeMedia) this.stage.scrollTo({ left: activeMedia.offsetLeft, behavior: 'auto' });
      const bound = this.dots.map((dot) => {
        const handler = () => this.scrollToMedia(dot.dataset.mediaId);
        dot.addEventListener('click', handler);
        return { dot, handler };
      });
      this._sliderCleanup = () => {
        bound.forEach(({ dot, handler }) => dot.removeEventListener('click', handler));
      };
      this._sliderObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.setActiveDot(entry.target.dataset.mediaId);
        });
      }, { root: this.stage, threshold: 0.6 });
      this.medias.forEach((m) => this._sliderObserver.observe(m));
    }
    scrollToMedia(mediaId) {
      const target = this.medias.find((m) => m.dataset.mediaId === String(mediaId));
      if (!target) return;
      target.scrollIntoView({ behavior: this.motionOff() ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
    }
    setActiveDot(mediaId) {
      const id = String(mediaId);
      let index = -1;
      this.dots.forEach((dot, i) => {
        const on = dot.dataset.mediaId === id;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) index = i;
      });
      if (this.counter && index > -1) this.counter.textContent = (index + 1) + ' / ' + this.medias.length;
    }
    show(mediaId) {
      if (!mediaId) return;
      let index = 0;
      this.medias.forEach((m, i) => {
        const on = m.dataset.mediaId === String(mediaId);
        m.classList.toggle('is-active', on);
        if (on) index = i;
        if (!on) { const v = m.querySelector('video'); if (v) v.pause(); }
      });
      this.thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.mediaId === String(mediaId)));
      if (this.counter) this.counter.textContent = (index + 1) + ' / ' + this.medias.length;
      // Below 749px .is-active no longer drives visibility (the mobile media
      // query turns the stage into a scroll-snap slider), so a variant change
      // must also move the slider and resync the dots — otherwise the slide in
      // view and the marked dot both go stale after the next variant pick.
      if (this.stage && window.matchMedia('(max-width: 749px)').matches) {
        this.setActiveDot(mediaId);
        const target = this.medias.find((m) => m.dataset.mediaId === String(mediaId));
        if (target) {
          this.stage.scrollTo({ left: target.offsetLeft, behavior: this.motionOff() ? 'auto' : 'smooth' });
        }
      }
    }
    step(delta) {
      if (!this.medias.length) return;
      let index = this.medias.findIndex((m) => m.classList.contains('is-active'));
      if (index < 0) index = 0;
      const nextIndex = (index + delta + this.medias.length) % this.medias.length;
      this.show(this.medias[nextIndex].dataset.mediaId);
    }
    openLightbox(mediaId) {
      if (!this.lightbox) return;
      const source = this.querySelector('.gallery__media[data-media-id="' + mediaId + '"] img');
      const holder = this.lightbox.querySelector('.gallery__lightbox-media');
      holder.innerHTML = '';
      if (source) {
        const img = document.createElement('img');
        img.src = source.currentSrc || source.src;
        img.alt = source.alt || '';
        holder.appendChild(img);
      }
      if (typeof this.lightbox.showModal === 'function') this.lightbox.showModal();
    }
  }
  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', MediaGallery);
  }
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('media-gallery').forEach((el) => {
      if (typeof el.initSlider === 'function') el.initSlider();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      this.abort = null;
      if (!this.input) return;
      this.input.addEventListener('input', this.debounce(() => this.search(), 250));
    }
    debounce(fn, wait) {
      let t;
      return (...a) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, a), wait); };
    }
    search() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ''; this.input.setAttribute('aria-expanded', 'false'); return; }
      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      this.dataset.loading = 'true';
      const url = `${window.Shopify ? window.Shopify.routes.root : '/'}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article,query&section_id=predictive-search`;
      fetch(url, { signal: this.abort.signal })
        .then((r) => r.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const inner = html.querySelector('#predictive-search-results');
          this.results.innerHTML = inner ? inner.innerHTML : '';
          this.input.setAttribute('aria-expanded', 'true');
          if (this.status) {
            var count = this.results.querySelectorAll('[role="option"], .predictive__item').length;
            this.status.textContent = count
              ? (this.dataset.i18nResults || '').replace('[count]', count)
              : (this.dataset.i18nNoResults || '');
          }
          this.dataset.loading = 'false';
        })
        .catch(() => { this.dataset.loading = 'false'; });
    }
  }
  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }
  } catch(e) { console.error(e); }
})();

})();
